import { Phone, Mail } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const ContactInfo = () => (
  <div className="contact-details">
    <div className="contact-item">
      <div className="contact-icon"><Phone size={24} /></div>
      <div className="contact-item-content">
        <div className="contact-label">Téléphone</div>
        <a href={`tel:${companyInfo.contact.phone}`} className="contact-value">
          {companyInfo.contact.phone}
        </a>
      </div>
    </div>
    <div className="contact-item">
      <div className="contact-icon"><Mail size={24} /></div>
      <div className="contact-item-content">
        <div className="contact-label">Courriel</div>
        <a href={`mailto:${companyInfo.contact.email}`} className="contact-value">
          {companyInfo.contact.email}
        </a>
      </div>
    </div>
  </div>
);

export default ContactInfo;
